import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { beginCatalogRefresh, refreshCartProducts } from '../redux/Slices/Cart';
import { fetchCurrentProducts } from '../utils/currentProducts';

export default function CartCatalogMonitor() {
  const dispatch = useDispatch();
  const idsKey = useSelector(state => JSON.stringify([...new Set(state.cartSlice.items.map(item => item.productId))].sort()));
  useEffect(() => {
    const ids = JSON.parse(idsKey);
    if (!ids.length) return;
    let controller;
    const refresh = async () => {
      controller?.abort();
      controller = new AbortController();
      const current = controller;
      dispatch(beginCatalogRefresh());
      const results = await fetchCurrentProducts(ids, current.signal);
      if (!current.signal.aborted) dispatch(refreshCartProducts(results));
    };
    refresh();
    const onFocus = () => { if (!document.hidden) refresh(); };
    window.addEventListener('focus', onFocus);
    window.addEventListener('dolcehem:refresh-cart', refresh);
    const timer = window.setInterval(onFocus, 300000);
    return () => {
      controller?.abort();
      window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('dolcehem:refresh-cart', refresh);
    };
  }, [dispatch, idsKey]);
  return null;
}
